
    import '/opt/buildhome/repo/packages/x/docs/x-skill/prompt.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-skill/prompt.en-US.md?type=demo')
};